import { ApproverType } from '../types/approver-type';

export class BodyApproval {
  approved: boolean;
  approverType: ApproverType;
  comment: string;

  constructor(approved: boolean, approverType: ApproverType, comment: string) {
    this.approved = approved;
    this.approverType = approverType;
    this.comment = comment;
  }
}
